/*
 * @Description: antd组件按需加入
 * @Author: gjc
 * @LastEditTime: 2021-09-08 15:20:16
 * @LastEditors: Please set LastEditors
 */
import {
  Base,
  Affix,
  Anchor,
  AutoComplete,
  Alert,
  Avatar,
  BackTop,
  Badge,
  Breadcrumb,
  Button,
  Calendar,
  Card,
  Collapse,
  Carousel,
  Cascader,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  FormModel,
  Icon,
  Input,
  InputNumber,
  Layout,
  List,
  LocaleProvider,
  Menu,
  Mentions,
  Modal,
  Pagination,
  Popconfirm,
  Popover,
  Progress,
  Radio,
  Rate,
  Row,
  Select,
  Slider,
  Spin,
  Statistic,
  Steps,
  Switch,
  Table,
  Transfer,
  Tree,
  TreeSelect,
  Tabs,
  Tag,
  TimePicker,
  Timeline,
  Tooltip,
  Upload,
  Drawer,
  Skeleton,
  Comment,
  // ColorPicker,
  ConfigProvider,
  Empty,
  Result,
  Descriptions,
  PageHeader,
  Space,
  message
  // notification
} from 'ant-design-vue'
const components = [
  Alert,
  Avatar,
  Badge,
  Button,
  Card,
  Collapse,
  Checkbox,
  Col,
  DatePicker,
  Form,
  FormModel,
  Icon,
  Input,
  InputNumber,
  List,
  LocaleProvider,
  Menu,
  Mentions,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Slider,
  Spin,
  Switch,
  Table,
  Tree,
  TreeSelect,
  Tabs,
  Tag,
  TimePicker,
  Tooltip,
  Upload,
  Space,
  Skeleton,
  Comment,
  ConfigProvider,
  Empty,
  // Result,
  // Descriptions,
  // PageHeader,
  // Statistic,
  // Steps,
  // Rate,
  // Transfer,
  // Drawer,
  // Timeline,
  Popconfirm,
  // Popover,
  // Progress,
  Layout,
  // Base,
  // Affix,
  Anchor,
  // AutoComplete,
  Divider,
  Dropdown,
  // BackTop,
  // Breadcrumb,
  // Calendar,
  Carousel
  // Cascader,
]

export default {
  install(Vue) {
    components.map((component) => {
      Vue.use(component)
    })
    Vue.prototype.$message = message
    // Vue.prototype.$notification = notification
    Vue.prototype.$info = Modal.info
    Vue.prototype.$success = Modal.success
    Vue.prototype.$error = Modal.error
    Vue.prototype.$warning = Modal.warning
    Vue.prototype.$confirm = Modal.confirm
  }
}
